export const TEMPLATE_BUILDER_PARAMS = {
  multiAsset: 'fields',
  csv: 'csv',
};

export const TEMPLATE_TAGS = {
  csv: 'CSV Template',
  multiPrompt: 'Multi-Prompt',
};

export const TEMPLATE_TAG_COLORS = {
  purple: 'purple',
  yellow: 'yellow',
};

export const TEMPLATE_STATUS = {
  active: 'active',
  draft: 'draft',
  released: 'released',
};
